// export const AUTH_URL = 'https://api.hchug.ru/api/v1'
export const AUTH_URL = 'https://guard.api.okgnn.ru/api/v1'
export const AUTH_STORE_KEYS = ['login', 'refresh', 'logout'] as const;
export const MANUAL_LOGOUT_KEY = 'okgportal.manualLogout';
